<template lang="pug">
include /mixins
resource-loader-controller(
  :resource='$options.fileExtentionResource'
  :immediate='true',
)
  template(
    #default='{ receive, result, loading }'
  )
    +b.education-form
      +e.head
        +e.description.P  {{ _('Если образования нет, кратко опишите, в каком статусе Вы планируете посетить саммит (например, директор клиники, администратор, менеджер и т.д.).') }}
      +e.content
        validation-provider(
          v-slot="{ errors, validate }"
          :name='name'
          :bails='false'
          :ref='`${name}_valid`'
          :rules='rules'
        )
          div.relative
            input(
              type='hidden',
              :vid='name'
              :name='name'
              :ref='name'
              v-model='selectedEducationLevel'
            )
            +b.error-label--top.LABEL(v-if="errors.length") {{ errors[0] }}
            v-selection-controller(
              :options='educationLevels'
              :multiple='false',
              :key-getter="$options.keyGetter",
              v-model='selectedEducationLevel'
              v-slot="{ options, value: model, change }"
            )
              +b.tt-space_mt--3.tt-space_ml--3(v-for='{ value } in options')
                +b.d-control-static-input--appearance_inline.TAG(
                  :rules='{ required: { allowFalse: false } }',
                  :tag='"input"'
                  :input-label='value.label'
                  :key='`key_${value.value}`'
                  v-model='model'
                  :checked.props='model[0] && model[0].value == value.value'
                  :id='`level_${value.value}`'
                  :ref='`level_${value.value}`'
                  @change='change(value); setValue(value)'
                  type='radio'
                  name='level'
                )
                label.input-group__input(
                  :for='`level_${value.value}`'
                ) {{ value.label }}
      +e.input(
        v-if='selectedEducationLevel.input'
      )
        +e.description.P.tt-space_mt--5 {{ _('Если у Вас нет медицинского образования, пожалуйста, укажите Вашу профессиональную роль в области медицины (например: владелец клиники, руководитель медицинского бизнеса, администратор эстетического центра, представитель партнерской компании и т.п.).') }}
        d-control-textarea(
          :input-label='_("Укажите вашу профессиональную роль")'
          key='education_comment'
          v-model='education_comment'
          class='is-textarea'
          rules='required'
          ref='education_comment'
          name='education_comment'
          @input='setComment($event)'
          rows='5'
        )
      +e.loader(
      )
        validation-provider(
          v-slot="{ errors, validate }"
          :name='file_name'
          :bails='false'
          :ref='`${file_name}_valid`'
          :rules='{ required: !selectedEducationLevel.input, minValid: 1 }'
        )
          div.relative
            input(
              type='hidden',
              :vid='file_name'
              :name='file_name'
              :ref='file_name'
              v-model='files'
            )
            +b.error-label--top.LABEL(v-if="errors.length") {{ errors[0] }}
            TicketManagementGallery(
              :id='`review_photo`',
              reset='reset'
              id='education'
              filekey='file'
              :initial='files'
              :ticket='ticket'
              :ticket_hash='ticket_hash'
              :post-resource='$options.createDocument'
              :delete-resource='$options.deleteDocument'
              @update='setKeys($event, "photos")'
              :extentions='result'
              @load='$emit("load", $event)'
            )
</template>

<script>
import {
  createDocument,
  deleteDocument,
} from '@api/ticket_management.service'

import {
  fileExtentionResource,
} from '@api/vendor.service'

import TicketManagementGallery from '@app/TicketManagement/Gallery'

import FileLoader from '@app/TicketManagement/FileLoader'

const EDUCATION_LEVEL_HIGHER = 'higher_medical'
const EDUCATION_LEVEL_SECONDARY = 'secondary_medical'
export const EDUCATION_LEVEL_NONE = 'no_medical'

export default {
  name: 'Education',
  keyGetter: x => `${x.value}`,
  props: {
    name: {
      default: 'medical_education_level',
    },
    form: {},
    ticket: {},
    ticket_hash: {},
  },
  createDocument,
  deleteDocument,
  fileExtentionResource,
  components: {
    FileLoader,
    TicketManagementGallery,
  },
  data() {
    return {
      file_name: 'education_documents',
      education_comment: this.form.education_comment || '',
      educationLevels: [
        {
          value: EDUCATION_LEVEL_HIGHER,
          label: this._('Высшее медицинское'),
          input: false,
          required: true,
        },
        {
          value: EDUCATION_LEVEL_SECONDARY,
          label: this._('Среднее медицинское'),
          input: false,
          required: true,
        },
        {
          value: EDUCATION_LEVEL_NONE,
          label: this._('Без медицинского образования'),
          input: true,
          required: false,
        },
      ],
      titles: {
        create: this._('Загрузить После'),
        update: this._('Изменить После'),
        initial: this._('Фото После'),
      },
      selectedEducationLevel: null,
      files: this.form.education_documents || [],
      rules: { required: true },
    }
  },

  created() {
    this.selectedEducationLevel = this.form.medical_education_level || this.educationLevels[0]
    this.$emit('input', this.form.medical_education_level || this.educationLevels[0])
  },
  methods: {
    setKeys(keys) {
      this.files = keys
      this.$emit('update', { education_documents: keys })
    },
    setComment(keys) {
      this.education_comment = keys
      this.$emit('update', { education_comment: keys })
    },
    setValue(value) {
      this.selectedEducationLevel = value
      this.$emit('input', value)
      this.required = value.required
    },
    // async createDocument() {
    //   const { data } = await this.createDocument({
    //     type: this.selectedEducationLevel,
    //     file: this.file,
    //   })
    //   this.setKeys(data)
    // },
    // async deleteDocument() {
    //   await this.deleteDocument(this.file)
    //   this.setKeys(null)
    // },
  },
}
</script>
